module.exports = __webpack_public_path__ + "img/delete-row.ee2988e1.svg";